import styled from '@emotion/styled';
import {TextareaAutosize} from '@mui/material';
import React from 'react';

import {
  mixinInputDisabled,
  mixinInputError,
  mixinInputValid,
} from '@ELib/styles/mixins';

import {FormInputWrapper} from './FormInputWrapper';
import {stopKeyboardEventPropagation} from './keyboardEventPropgation';
import {SharedProps} from './sharedProps';

export type ETextAreaProps = SharedProps & {
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
  value?: string;
  autoComplete?: string;
  minRows?: number;
  maxRows?: number;
  /** classname that gets applied to the FormInputWrapper element */
  className?: string;
};

export const ETextArea = ({
  label,
  labelInfo,
  bottomText,
  onChange,
  onFocus,
  onBlur,
  name,
  value,
  disabled,
  autoComplete,
  autoFocus,
  ariaLabel,
  minRows,
  maxRows,
  error,
  errorMessage,
  className,
}: ETextAreaProps): React.ReactElement => (
  <FormInputWrapper
    bottomText={bottomText}
    className={className}
    error={error}
    errorMessage={errorMessage}
    label={label}
    labelInfo={labelInfo}
    labelProps={{htmlFor: name}}
  >
    <StyledTextArea
      aria-label={ariaLabel}
      autoComplete={autoComplete}
      autoFocus={autoFocus}
      data-testid={`ETextArea-${name}`}
      disabled={disabled}
      error={error}
      id={name}
      maxRows={maxRows}
      minRows={minRows}
      name={name}
      value={value}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      onKeyDown={stopKeyboardEventPropagation}
    />
  </FormInputWrapper>
);

const StyledTextArea = styled(TextareaAutosize, {
  shouldForwardProp: (props) => props !== 'error',
})<{error?: boolean}>`
  ${({error}) => (error ? mixinInputError : mixinInputValid)};

  min-width: 100%;
  max-width: min-content;

  &[disabled] {
    ${mixinInputDisabled}
  }
`;
